import React, { useState } from 'react';

import { Icon } from '@column/column-ui-kit';

import { EventsSheet } from './EventsSheet';

export const EventsButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="hidden md:flex h-9 cursor-pointer items-center gap-1.5 rounded-lg pl-2 pr-2.5 text-sm font-medium text-gray-600 transition-[background-color,color] duration-150 ease-out hover:bg-gray-100 hover:text-gray-900 dark:text-sidebar-foreground/80 dark:hover:bg-white/[0.08] dark:hover:text-sidebar-foreground [&_svg]:[--icon-color:var(--color-gray-500)]! dark:[&_svg]:[--icon-color:hsl(var(--sidebar-icon))]! hover:[&_svg]:[--icon-color:var(--color-gray-700)]! dark:hover:[&_svg]:[--icon-color:hsl(var(--sidebar-foreground))]! [&_svg_path]:transition-[stroke,fill] [&_svg_path]:duration-150"
        aria-label="Open events"
      >
        <Icon.Calendar className="size-4" />
        <span>Events</span>
      </button>
      <EventsSheet open={open} onOpenChange={setOpen} />
    </>
  );
};
